var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('primary-button',{on:{"click":_vm.checkout}},[_vm._v("直接購買")])}
var staticRenderFns = []

export { render, staticRenderFns }